import React from 'react';
import PrettyLink from '~atoms/pretty-link'
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import { imagePrettyUrl, getAltText } from '~helpers/getters';
import Bonus from 'gatsby-core-theme/src/components/molecules/bonus-box/template-four';
import OperatorCta from 'gatsby-core-theme/src/components/atoms/button/operator-cta';
import styles from './header-operator-bannner.module.scss';
import Coupon from 'gatsby-matrix-theme/src/components/atoms/coupon';
import Button from 'gatsby-core-theme/src/components/atoms/button/button';

import useTranslate from '~hooks/useTranslate/useTranslate';
import { TrackingKeys } from '~constants/tracking-api'

import { IoMdArrowRoundForward } from '@react-icons/all-files/io/IoMdArrowRoundForward';
import Tnc from 'gatsby-core-theme/src/components/molecules/tnc';

const HeaderOperatorBaner = ({
  pageTemplate,
  operator,
  moduleName = TrackingKeys?.OPERATORBANNER,
  modulePosition,
}) => {
  const couponCode = operator?.extra_fields?.coupon_code;
  const imageObject = operator?.logo || operator?.standardised_logo_url_object;

  const status = operator?.status;

  const btnText = {
    inactive_: 'This casino is currently Inactive',
    coming_soon_: 'This casino is coming soon',
    not_recommended_: 'This Casino is not recommended',
    blacklisted_: 'This Casino is blacklisted',
  };

  return (
    <div id="operator-banner" className={`${styles.operatorBannerContainer}`}>
      {!['inactive', 'not_recommended', 'blacklisted'].includes(status) ? (
        <>
          <div className={`${styles.topContainer}`}>
            <PrettyLink
              operator={operator}
              pageTemplate={pageTemplate}
              moduleName={moduleName}
              rel="nofollow noreferrer sponsored"
              className={`${styles.logo} operator-banner-gtm logo-cta`}
            >
              <LazyImage
                src={
                  imageObject && imageObject.filename
                    ? imagePrettyUrl(imageObject.filename, 64, 64)
                    : '/images/default-operator.png'
                }
                loading="eager"
                width={64}
                height={64}
                target="_blank"
                alt={getAltText(imageObject, operator?.name)}
              />
            </PrettyLink>


            <div className={styles.bonusContainer}>
              <Bonus
                item={operator}
                tracker="main"
                moduleName={moduleName}
                modulePosition={modulePosition}
                pageTemplate={pageTemplate}
              />
            </div>

            <div className={styles.couponCtaContainer}>
              <Coupon code={couponCode} status={operator?.status} />

              <OperatorCta
                icon={<IoMdArrowRoundForward title="Right-pointing Arrow Icon" />}
                operator={operator}
                moduleName={moduleName}
                gtmClass="operator-banner-operator-cta-gtm"
                pageTemplate={pageTemplate}
                translationsObj={{
                  active: { translationKey: 'play_now', defaultValue: 'Play now' },
                  not_recommended: {
                    translationKey: 'not_recommended',
                    defaultValue: 'Not Recommended',
                  },
                  coming_soon: { translationKey: 'coming_soon', defaultValue: 'Soon Available' },
                  inactive: {
                    translationKey: 'inactive',
                    defaultValue: 'Not Accepting New Players',
                  },
                  blacklisted: { translationKey: 'blacklisted', defaultValue: 'Blacklisted' },
                }}
                modulePosition={modulePosition}
              />
            </div>
          </div>
          <Tnc operator={operator} isFixed />
        </>
      ) : (
        <div className={styles.nonActiveStatus}>
          <p>{useTranslate(status + '_', btnText[status + '_'])}</p>
          <Button
            to="/"
            btnText="Go to Home Page"
            targetBlank={false}
            buttonType="primary"
            buttonSize="m"
            isInternalLink={true}
            icon={null}
          />
        </div>
      )}
    </div>
  );
};

export default HeaderOperatorBaner;
